import { render } from "./fivePoints.vue?vue&type=template&id=75f43811&scoped=true"
import script from "./fivePoints.vue?vue&type=script&lang=js"
export * from "./fivePoints.vue?vue&type=script&lang=js"

import "./fivePoints.vue?vue&type=style&index=0&id=75f43811&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75f43811"]])

export default __exports__